<template>
  <div style="text-align:left">ok</div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created() {
    this.monit();
  },
  methods: {
    monit() {
      const _query = this.$route.query;
      const params = {
        userid: _query.userid, // 账户ID
        aid: _query.aid, // 创意ID
        pid: _query.pid, // 计划ID
        uid: _query.uid, // 单元ID
        productid: _query.productid, // 商品ID
        click_id: _query.click_id, // 点击唯一ID
        idfa: _query.idfa, // IOS设备标识
        imei_md5: _query.imei_md5, // 安卓设备标识
        oaid: _query.oaid, // Android Q 及更高版本的设备号
        oaid_md5: _query.oaid_md5, // Android Q 及更高版本的设备号
        android_id_md5: _query.android_id_md5, // 安卓id，该设备识别号与设备可能存在多对一或一对多的关系
        mac: _query.mac, // MAC地址
        mac_md5: _query.mac_md5, // 用户终端的eth0接口的MAC地址
        ip: _query.ip,
        ip_type: _query.ip_type, // IP地址类型 v4: ipv4 v6: ipv6
        ua: _query.ua, // 数据上报终端设备User Agent
        os_version: _query.os_version, // 从UA中解析出来系统版本
        os: _query.os, // 操作系统类型
        ts: _query.ts, // 时间戳，单位：毫秒(ms) 点击时间
        device_info: _query.device_info, // 设备信息, 发生广告点击的设备机型
        interactionsType: _query.interactionsType, // 广告互动类型
        caid: _query.caid, // 设备标识
        query: _query.query // 搜索关键词 不确定是否存在
      };
      this.$axios
        .post("/api/insureadmin/semMonitorService/baiduLaunchMonitor", params)
        .then(res => {
          console.log(res);
        });
    }
  }
};
</script>
